// eslint-disable-next-line no-use-before-define
import React, { Component, Suspense } from 'react';
import {
  Form,
  Modal,
  Row,
  Col,
  Button,
  notification,
  Tabs,
  List,
  Divider,
} from 'antd';
import {
  ArrowsAltOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
} from '@ant-design/icons';
import moment from 'moment';
import {
  sExecuteEvent,
  sLoadCheck,
  sLoadConseq,
  sSaveProcTaskCheck,
  sUpdateProcTaskCheckStatus,
  sLoadStep,
  loadParList,
  getContractByID,
  getClientInvoicebyID,
  getSupplierInvoicebyID,
  getPaymentbyID,
} from '../../utils/APIUtils';
import PageLoading from '../Welcome/components/PageLoading';
import { getAssetsByID } from '../../services/assets';
import { getThirdPartyById } from '../../services/thirdParty';
import { getProposalUsedAmounts } from '../../services/proposal';

const TabRejectPayment = React.lazy(() => import('./tabRejectPayment'));
const TabPaymentSI = React.lazy(() => import('./TabPaymentSupplierInvoice'));
const TabPaymentCI = React.lazy(() => import('./TabPaymentClientInvoice'));

const TabCreditNoteSI = React.lazy(() =>
  import('./TabCreditNoteSupplierInvoice')
);
const TabUpload = React.lazy(() => import('./tabUpload'));
const TabDecision = React.lazy(() => import('./tabDecision'));
const TabTPAddress = React.lazy(() => import('./tabTPAddress'));
const TabScoring = React.lazy(() => import('./tabScoring'));

const TabGuaranty = React.lazy(() => import('./tabGuaranty'));
const TabPropAssetOrdering = React.lazy(() => import('./tabPropAssetOrdering'));
const TabAssetActivation = React.lazy(() => import('./tabAssetActivation'));

const { TabPane } = Tabs;

const lwiz = [
  { steporder: '10', funcode: 'tabRejectPayment' },
  { steporder: '11', funcode: 'tabPaymentSI' },
  { steporder: '12', funcode: 'tabCreditNoteSI' },
  { steporder: '13', funcode: 'tabPaymentCI' },
];

class EXECUTETask extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      url: 'Empty',
      printlabel: 'Empty',
      displayPrint: false,
      CHECKList: [],
      CONSEQList: [],
      CheckOK: true,
      disableExecTask: false,
      activeKey: '3',
      ResultExecuteEvent: 'not executed',
      taskid: 0,
      funcode: '',
      object: '',
      objectid: 0,
      succes: false,
      wiz: lwiz,
      REJREASON: [],
    };
  }

  handlerTabGuaranty = (tpidGuarantor, tpidBeneficiary) => {
    this.formRef.current.setFieldsValue({
      tpidbeneficiary: tpidBeneficiary,
      tpidguarantor: tpidGuarantor,
    });
  };

  handlerTabAssetActivation = (
    listAsset,
    investAmount,
    finAmount,
    ctduration,
    residualValue
  ) => {
    let llistAsset = '';
    if (listAsset === '') {
      llistAsset = '';
    } else {
      llistAsset = `${listAsset},`;
    }
    this.formRef.current.setFieldsValue({
      listAsset: llistAsset,
      investAmount,
      finAmount,
      ctduration,
      residualValue,
    });
  };

  handlerTabPropAssetOrdering = (val) => {};

  componentDidMount() {
    this.setState({
      object: this.props.object,
      objectid: this.props.objectid,
      taskid: this.props.taskid,
      funcode: this.props.funcode,
      disableExecTask: false,
    });

    if (this.props.objectid != null) {
      this.loadWizard(
        this.props.taskid,
        this.props.object,
        this.props.objectid
      );
      this.LoadCheck(this.props.taskid);
    }

    if (this.props.object === 'PAYMENT') {
      this.loadParList('REJREASON');
    }

    if (this.props.objectid !== null) {
      this.setState({ objectid: this.props.objectid });

      if (this.props.object === 'CONTRACT') {
        this.loadCTDetail(this.props.objectid);
      }

      if (this.props.object === 'PROPOSAL') {
        this.loadCTDetail(this.props.objectid);
      }

      if (this.props.object === 'THIRDPARTY') {
        this.loadTPDetail(this.props.objectid);
      }
      if (this.props.object === 'ASSET') {
        this.loadASSETDetail(this.props.objectid);
      }

      if (this.props.object === 'CINVOICE') {
        this.loadCIDetail(this.props.objectid);
      }
      if (this.props.object === 'SINVOICE') {
        this.loadSIDetail(this.props.objectid);
      }
      if (this.props.object === 'PAYMENT') {
        this.loadPAYDetail(this.props.objectid);
      }
    } else {
      notification.error({ message: 'Parameter ObjectID not received' });
    }
  }

  initFields = (contract, initAmounts) => {
    const elemFin = contract.conElements.find((e) => e.ctetype === 'FIN');
    this.formRef.current.setFieldsValue({
      dectype: 'MANUAL',
      declevel: contract.ctdecisionlevel,
      decdate: moment(),
      decexternalref: '',
      deccomment: '',
      decscore: '',
      reqfinamount: elemFin.cteinvestamount,
      finamountapproved: elemFin.cteinvestamount,
      firstpayment: elemFin.ctefirstpayment,
      firstpaymentapproved: elemFin.ctefirstpayment,
      residualvalue: elemFin.ctervamount,
      residualvalueapproved: elemFin.ctervamount,
      deposit: elemFin.ctedepositamount,
      depositapproved: elemFin.ctedepositamount,
      rate: elemFin.ctenominalrate,
      rateapproved: elemFin.ctenominalrate,
      duration: elemFin.cteduration,
      durationapproved: elemFin.cteduration,
      assetnote: '',
      warrantynote: '',
      insurancenote: '',
      coborrowernote: '',
      guarantornote: '',
      finamountreserve: false,
      firstpaymentreserve: false,
      residualvaluereserve: false,
      depositreserve: false,
      ratereserve: false,
      durationreserve: false,
      assetreserve: false,
      warrantyreserve: false,
      insurancereserve: false,
      coborrowerreserve: false,
      guarantorreserve: false,
      deliveryadrstreet1: contract.ctinvoiceaddressstr1,
      deliveryadrstreet2: contract.ctinvoiceaddressstr2,
      deliveryadrzipcode: contract.ctinvoiceaddresszipcode,
      deliveryadrcity: contract.ctinvoiceaddresscity,
      deliveryadrregion: contract.ctinvoiceaddressregion,
      upfrontAmount: elemFin.cteupfrontamount - initAmounts.upfrontused,
      participationAmount: elemFin.ctepartamount - initAmounts.partused,
      startDate: moment(),
      billingDate: contract.ctbillingdate,
      depositAmount: elemFin.ctedepositamount - initAmounts.depositused,
      finAmount: 0,
      investAmount: 0,
      invoiceUpfront: false,
      invoiceParticipation: false,
      invoiceDeferredinterest: false,
      invoiceDeposit: false,
      invoiceFirstrental: false,
      generateDisbursment: false,
      generateCommission: false,
      listAsset: '',
    });
  };

  loadCTDetail = (ctrid) => {
    getContractByID(ctrid).then((response) => {
      this.setState({
        data: response,
      });
      getProposalUsedAmounts({ ctrid }).then((response2) => {
        this.initFields(response, response2.data);
      });
    });
  };

  loadTPDetail = (tpid) => {
    getThirdPartyById({ tpid }).then((response) => {
      this.setState({ data: response.data });
    });
  };

  loadASSETDetail = (assetid) => {
    getAssetsByID({ assetid }).then((response) => {
      this.setState({ data: response.data });
    });
  };

  loadCIDetail = (param) => {
    getClientInvoicebyID(param).then((response) => {
      this.setState({ data: response });
    });
  };

  loadSIDetail = (param) => {
    getSupplierInvoicebyID(param).then((response) => {
      this.setState({ data: response });
    });
  };

  loadPAYDetail = (param) => {
    getPaymentbyID(param).then((response) => {
      this.setState({ data: response });
    });
  };

  loadParList = (param) => {
    loadParList(param)
      .then((response) => {
        if (param === 'REJREASON') {
          this.setState({ REJREASON: response.content });
        }
      })
      .catch((err) => {
        notification.error({ message: 'Error', description: err });
      });
  };

  saveProcTaskConseq(conseqid) {}

  saveProcTaskCheck(
    procid,
    proctaskid,
    proctaskcheckid,
    proccode,
    procmodule,
    entityid,
    taskid,
    checkid,
    checkorder,
    checktype,
    checkcode,
    checkrequesttype,
    receivertype,
    receiverid,
    receiverroleprofile,
    proccodetarget,
    taskidtarget,
    doccode,
    ccode,
    checkstatus
  ) {
    let status = 'INIT';
    if (checkrequesttype === 'OVERRIDE') {
      status = 'OVERRIDE';
    }
    let taskidtar = '';
    let receiveridtar = '';

    if (receiverid !== null) {
      receiveridtar = receiverid;
    }
    if (taskidtarget !== null) {
      taskidtar = taskidtarget;
    }

    if (checkrequesttype === 'REQVAL' && checkstatus === 'INIT') {
      status = 'CANCEL';
    }

    let promise;
    if (status === 'CANCEL') {
      promise = sUpdateProcTaskCheckStatus(proctaskcheckid, status);
    } else {
      promise = sSaveProcTaskCheck(
        procid,
        proctaskid,
        proctaskcheckid,
        proccode,
        procmodule,
        entityid,
        taskid,
        checkid,
        checkorder,
        checktype,
        checkcode,
        checkrequesttype,
        receivertype,
        receiveridtar,
        receiverroleprofile,
        proccodetarget,
        taskidtar,
        doccode,
        ccode,
        status
      );
    }

    promise.then((response) => {
      this.LoadCheck(taskid);
    });
  }

  LoadCheck(taskid) {
    sLoadCheck(taskid, this.props.object, this.props.objectid).then(
      (response) => {
        this.setState({ CHECKList: response, CheckOK: true });
        if (response.length > 0) {
          this.setState({ activeKey: 'tabCheck' });
        }
        for (const j in response) {
          if (response[j].controlCheck === false) {
            this.setState({ CheckOK: false, disableExecTask: true });
            break;
          }
        }
        if (this.state.CheckOK === true) {
          this.LoadConseq(taskid);
        }
      }
    );
  }

  LoadConseq(taskid) {
    sLoadConseq(taskid, this.state.object, this.state.objectid).then(
      (response) => {
        this.setState({ CONSEQList: response });
      }
    );
  }

  loadWizard = (itaskid, iobject, iobjectid) => {
    let promise;
    if (iobjectid !== null) {
      promise = sLoadStep(itaskid, iobject, iobjectid);
    } else {
      // promise = sLoadHomeTask(itaskid);
    }
    promise.then((response) => {
      this.setState({ wiz: response });
      if (response.length > 0) {
        this.setState({ activeKey: response[0].funcode });
      } else {
        this.setState({ activeKey: 'tabCheck' });
      }
    });
  };

  ExecuteEvent = (values) => {
    if (this.state.funcode === '') {
      notification.error({
        message:
          'There is no service set up for this task. Please review the configuration',
        description: `taskid = ${this.state.taskid} the event cannot be executed`,
      });
      return;
    }

    this.formRef.current
      .validateFields()
      .then((values) => {
        let params = this.state.funcode;
        let lvalue = null;
        for (const el in values) {
          switch (el) {
            case 'rejectdate':
              params += `${el}=${moment(values[el]).format(
                'YYYY-MM-DD'
              )}T00:00:00.0Z&`;
              break;
            case 'decdate':
              params += `${el}=${moment(values[el]).format('YYYY-MM-DD')}&`;
              break;
            case 'guarreceptiondate':
              params += `${el}=${moment(values[el]).format('YYYY-MM-DD')}&`;
              break;
            case 'guarsignaturedate':
              params += `${el}=${moment(values[el]).format('YYYY-MM-DD')}&`;
              break;
            case 'poexpecteddeliverydate':
              params += `${el}=${moment(values[el]).format('YYYY-MM-DD')}&`;
              break;
            case 'startDate':
              params += `${el}=${moment(values[el]).format('YYYY-MM-DD')}&`;
              break;
            case 'deliveryDate':
              params += `${el}=${moment(values[el]).format('YYYY-MM-DD')}&`;
              break;
            default:
              lvalue = values[el];
              if (lvalue === null || isNaN(lvalue)) {
                lvalue = '';
              }
              params += `${el}=${lvalue}&`;
          }
        }

        this.setState({ activeKey: 'tabConsequence' });
        sExecuteEvent(
          params,
          this.state.taskid,
          this.state.object,
          this.state.objectid
        ).then((response) => {
          const ll_text = document.createElement('div');
          ll_text.innerHTML = response.message;
          ll_text.innerHTML = ll_text.textContent;

          const l_message = (
            <html>
              <div style={{ color: 'green' }}>{ll_text.innerHTML}</div>
            </html>
          );

          this.setState({ ResultExecuteEvent: l_message });
          notification.info({
            message: 'Task executed successfully',
            description: l_message,
          });

          if (response.success === true) {
            this.setState({
              taskid: response.taskid,
              disableExecTask: true,
              succes: true,
            });
            this.ExecuteEventConseq(
              response.proctaskid,
              response.procid,
              response.taskid,
              response.entity,
              response.entityid
            );
            this.LoadConseq(response.taskid);
          }
        });
      })
      .catch((err) => {
        notification.error({ message: 'Mandatory fields are not set' });
      });
  };

  ExecuteEventConseq(proctaskid, procid, taskid, entity, entityid) {}

  handleOkModal = (e) => {
    if (this.state.succes === true) {
      this.props.handlerModalExecuteTask('Refresh');
    } else {
      this.props.handlerModalExecuteTask('none');
    }
  };

  handleCancelPrint = (e) => {
    this.setState({ displayPrint: false });
  };

  handleCancelModal = (e) => {
    if (this.state.succes === true) {
      this.props.handlerModalExecuteTask('Refresh');
    } else {
      this.props.handlerModalExecuteTask('none');
    }
  };

  onChange = (activeKey) => {
    this.setState({ activeKey });
  };

  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };

  NextTab = () => {
    const lkey = Number(this.state.activeKey) + 1;
    this.setState({ activeKey: lkey.toString() });
  };

  PreviousTab = () => {
    const lkey = Number(this.state.activeKey) - 1;
    this.setState({ activeKey: lkey.toString() });
  };

  setTabKey = (tabName) => {
    let key = 50;
    try {
      key = this.state.wiz.find((tb) => tb.funcode === tabName).steporder;
      return key;
    } catch (error) {
      return 50;
    }
  };

  renderREJREASON() {
    if (this.state.REJREASON.length > 0) {
      return this.state.REJREASON.map((data) => (
        <option key={data.parvalue}>{data.parlistlabel}</option>
      ));
    }
  }

  print = (domaine, url, printlabel) => {
    this.setState({ url, printlabel, displayPrint: true });
  };

  loadComponent(url) {
    const Component = React.lazy(() => import(`../Print/${url}`));
    return Component;
  }

  render() {
    const MyDocument = this.loadComponent(this.state.url);

    const { loading } = this.props;
    const { isVisibleTask } = this.props;
    const titleModal = `${this.props.titleModal} ${this.props.objectreference}`;
    const optionsREJREASON = this.renderREJREASON();

    const tabTPAddress = (
      <TabPane key="tabTPAddressEv" tab="Change Third Party Address">
        <Suspense fallback={<PageLoading />}>
          <TabTPAddress
            object={this.state.object}
            objectid={this.state.objectid}
            Data={this.state.data}
          />
        </Suspense>
      </TabPane>
    );

    const tabDecision = (
      <TabPane key="tabDecisionEv" tab="Enter Decision">
        <Suspense fallback={<PageLoading />}>
          <TabDecision
            object={this.state.object}
            objectid={this.state.objectid}
            Data={this.state.data}
          />
        </Suspense>
      </TabPane>
    );

    const tabScoring = (
      <TabPane key="tabScoringEv" tab="tabScoringEv">
        <Suspense fallback={<PageLoading />}>
          <TabScoring
            object={this.state.object}
            objectid={this.state.objectid}
          ></TabScoring>
        </Suspense>
      </TabPane>
    );

    const tabGuaranty = (
      <TabPane key="tabGuarantyEv" tab="Guaranty">
        <Suspense fallback={<PageLoading />}>
          <TabGuaranty
            object={this.state.object}
            objectid={this.state.objectid}
            Data={this.state.data}
            handlerTabGuaranty={this.handlerTabGuaranty}
          />
        </Suspense>
      </TabPane>
    );

    const tabAssetActivation = (
      <TabPane key="tabAssetActivation" tab="Asset Delivery & Activation">
        <Suspense fallback={<PageLoading />}>
          <TabAssetActivation
            object={this.state.object}
            objectid={this.state.objectid}
            Data={this.state.data}
            handlerTabAssetActivation={this.handlerTabAssetActivation}
          />
        </Suspense>
      </TabPane>
    );

    const tabPropAssetOrdering = (
      <TabPane key="tabPropAssetOrdering" tab="Assets Ordering">
        <Suspense fallback={<PageLoading />}>
          <TabPropAssetOrdering
            object={this.state.object}
            objectid={this.state.objectid}
            Data={this.state.data}
            handlerTabPropAssetOrdering={this.handlerTabPropAssetOrdering}
          />
        </Suspense>
      </TabPane>
    );

    const tabUpload = (
      <TabPane key="tabUpload" tab="Upload documents">
        <Suspense fallback={<PageLoading />}>
          <TabUpload
            object={this.state.object}
            objectid={this.state.objectid}
          />
        </Suspense>
      </TabPane>
    );

    const tabRejectPayment = (
      <TabPane key="tabRejectPayment" tab="Reject Payment">
        <Suspense fallback={<PageLoading />}>
          <TabRejectPayment
            loading={loading}
            optionsREJREASON={optionsREJREASON}
          />
        </Suspense>
      </TabPane>
    );

    const tabPaymentSI = (
      <TabPane key="tabPaymentSI" tab="Payment SI">
        <Suspense fallback={<PageLoading />}>
          <TabPaymentSI loading={loading}> </TabPaymentSI>
        </Suspense>
      </TabPane>
    );

    const tabPaymentCI = (
      <TabPane key="tabPaymentCI" tab="Payment CI">
        <Suspense fallback={<PageLoading />}>
          <TabPaymentCI loading={loading}> </TabPaymentCI>
        </Suspense>
      </TabPane>
    );

    const tabCreditNoteSI = (
      <TabPane key="tabCreditNoteSI" tab="Credit Note SI">
        <Suspense fallback={<PageLoading />}>
          <TabCreditNoteSI loading={loading}> </TabCreditNoteSI>
        </Suspense>
      </TabPane>
    );

    const tabCheck = (
      <TabPane key="tabCheck" tab="Check" closable={false} forceRender>
        <div>
          <List
            itemLayout="horizontal"
            size="small"
            header={
              <div style={{ color: 'blue' }}>List of checked controls</div>
            }
            bordered
            dataSource={this.state.CHECKList}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <div key={0}>
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        this.saveProcTaskCheck(
                          item.procID,
                          item.proctaskID,
                          item.proctaskcheckID,
                          item.proccode,
                          this.state.object,
                          item.entityid,
                          item.taskid,
                          item.checkid,
                          item.checkorder,
                          item.checktype,
                          item.checkcode,
                          item.checkrequesttype,
                          item.receivertype,
                          item.receiverid,
                          item.receiverRoleProfile,
                          item.proccodetarget,
                          item.taskidtarget,
                          item.doccode,
                          item.ccode,
                          item.checkStatus
                        );
                      }}
                    >
                      {' '}
                      {item.controlCheck === false &&
                        item.checkrequesttype === 'REQVAL' &&
                        item.checkStatus === null &&
                        item.checkRequestTypeLabel}
                      {item.controlCheck === false &&
                        item.checkrequesttype === 'REQVAL' &&
                        item.checkStatus === 'CANCEL' &&
                        item.checkRequestTypeLabel}
                      {item.controlCheck === false &&
                        item.checkrequesttype === 'REQVAL' &&
                        item.checkStatus === 'INIT' &&
                        'Cancel Request'}
                      {item.controlCheck === false &&
                        item.checkrequesttype === 'OVERRIDE' &&
                        item.checkStatus !== 'OVERRIDE' &&
                        'Override'}
                    </a>
                  </div>,
                ]}
              >
                <Row>
                  <Col span={16}>
                    {(item.controlCheck === true && (
                      <CheckCircleTwoTone twoToneColor="#52c41a" />
                    )) ||
                      (item.controlCheck === false && (
                        <CloseCircleTwoTone twoToneColor="red" />
                      ))}
                    &nbsp;{item.clabel} -{'>'} &nbsp; {item.cmessage}
                  </Col>
                  <Col span={8}>
                    {item.controlCheck === true && (
                      <div style={{ color: 'green' }}>OK Pass</div>
                    )}
                    {item.controlCheck === false &&
                      item.procID === 0 &&
                      item.checkrequesttype === 'REQVAL' && (
                        <div>
                          You can {item.checkRequestTypeLabel} to{' '}
                          {item.receiverTypeLabel}{' '}
                          {item.receiverRoleProfileLabel}
                        </div>
                      )}
                    {item.controlCheck === false &&
                      item.procID === 0 &&
                      item.checkrequesttype === 'OVERRIDE' && (
                        <div>You can {item.checkRequestTypeLabel}</div>
                      )}
                    {item.procID > 0 && (
                      <div style={{ color: 'blue' }}>
                        {item.statusLabel} by {item.userNameStatus} having a
                        role {item.receiverRoleProfileLabel}
                      </div>
                    )}
                  </Col>
                </Row>
              </List.Item>
            )}
          />
        </div>
      </TabPane>
    );

    const tabConsequence = (
      <TabPane
        key="tabConsequence"
        tab="Consequences"
        closable={false}
        forceRender
      >
        <div>
          <Row>
            <Col span={10}>Main task : {titleModal}</Col>
            <Col span={1} />
            <Col span={13} style={{ color: 'green' }}>
              Status : {this.state.ResultExecuteEvent}{' '}
            </Col>
          </Row>
          <Divider />
          <List
            itemLayout="horizontal"
            header={
              <div style={{ color: 'blue' }}>
                List of consequences of running this task
              </div>
            }
            bordered
            dataSource={this.state.CONSEQList}
            renderItem={(item) => (
              <List.Item
                actions={[
                  (item.conseqtype === 'PRINT' && (
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        this.print('', item.conseqcode, item.conseqlabel);
                      }}
                    >
                      {item.conseqlabel}
                    </a>
                  )) ||
                    (item.conseqtype !== 'PRINT' && (
                      <a>{item.conseqstatuslabel}</a>
                    )),
                ]}
              >
                <CheckCircleTwoTone twoToneColor="#52c41a" />&nbsp;
                {item.conseqtypelabel}&nbsp; : &nbsp;
                {item.conseqlabel} &nbsp;{item.tasktargetlabel}
                {item.conseqtype === 'NOTIF' &&
                  ` --> Send to ${item.receiverTypeLabel} ( ${item.receiverRoleProfileLabel}${item.userNameAction} )`}
              </List.Item>
            )}
          />
        </div>
      </TabPane>
    );

    const operations = (
      <Row>
        <Col span={24} style={{ textAlign: 'right' }}>
          <div>
            <Button
              style={{ marginLeft: '10px' }}
              type="primary"
              onClick={this.handleCancelModal}
            >
              Cancel
            </Button>

            <Button
              style={{ marginLeft: '10px' }}
              icon={<ArrowsAltOutlined />}
              onClick={this.ExecuteEvent}
              disabled={this.state.disableExecTask}
              type="primary"
            >
              Execute Task
            </Button>
          </div>
        </Col>
      </Row>
    );

    return (
      (<div>
        <Modal
          destroyOnClose
          title={titleModal}
          open={isVisibleTask}
          footer={null}
          onOk={this.handleOkModal}
          onCancel={this.handleCancelModal}
          width="1000px"
          style={{
            top: 20,
            right: 0,
          }}
        >
          <Form
            layout="vertical"
            ref={this.formRef}
            hideRequiredMark
            onFinish={this.ExecuteEvent}
            onFinishFailed={this.onFinishFailed}
          >
            <Tabs
              hideAdd
              type="card"
              onNextClick={this.NextTab}
              onChange={this.onChange}
              activeKey={this.state.activeKey}
              onEdit={this.onEdit}
              tabBarExtraContent={operations}
            >
              {this.state.wiz.map(
                (step) =>
                  (step.funcode === 'tabRejectPayment' && tabRejectPayment) ||
                  (step.funcode === 'tabCreditNoteSI' && tabCreditNoteSI) ||
                  (step.funcode === 'tabPaymentSI' && tabPaymentSI) ||
                  (step.funcode === 'tabPaymentCI' && tabPaymentCI) ||
                  (step.funcode === 'tabUpload' && tabUpload) ||
                  (step.funcode === 'tabDecisionEv' && tabDecision) ||
                  (step.funcode === 'tabTPAddressEv' && tabTPAddress) ||
                  (step.funcode === 'tabScoringEv' && tabScoring) ||
                  (step.funcode === 'tabGuarantyEv' && tabGuaranty) ||
                  (step.funcode === 'tabPropAssetOrdering' &&
                    tabPropAssetOrdering) ||
                  (step.funcode === 'tabAssetActivation' && tabAssetActivation)
              )}

              {tabCheck}

              {this.state.CheckOK && tabConsequence}
            </Tabs>
          </Form>
        </Modal>
        <Modal
          forceRender
          title={this.state.printlabel}
          bodyStyle={{ height: '600px' }}
          open={this.state.displayPrint}
          footer={null}
          onOk={this.handleCancelPrint}
          onCancel={this.handleCancelPrint}
          width="80%"
          style={{ top: 20 }}
        >
          <Suspense fallback={<div>waiting...</div>}>
            <MyDocument
              preview
              title={this.state.printlabel}
              data={this.state.data}
            />
          </Suspense>
        </Modal>
      </div>)
    );
  }
}
export default EXECUTETask;
